namespace Portico.Directives {
    import Inject = Portico.Decorators.Inject;
	import ps = Portico.Services;

    export interface IMonth {
        id: string;
        label: string;
    }

    export interface ITcTripleDateController extends angular.IController {
        _year: string;
        _month: string;
        _day: string;

		change: () => void;
        disabled: string;
        inputClass: string;
        key: string;
        pattern: string;
        placeholderMonth: string;
        placeholderDay: string;
        placeholderYear: string;
        readonly: string;
        required: string;

        tcForm: ITcFormController;
		id: string;

        years: string[];
        months: IMonth[];
        days: string[];

		isDisabled: () => boolean;
		//onChange: () => void;
        updateDays: () => void;
    }

    @Inject('$scope')
    export class TcTripleDateController implements ITcTripleDateController {
        _year: string;
        _month: string;
        _day: string;

		change: () => void;
        disabled: string;
        inputClass: string;
        key: string;
        pattern: string;
        placeholderMonth: string;
        placeholderDay: string;
        placeholderYear: string;
        readonly: string;
        required: string;

        tcForm: ITcFormController;
		id: string;

        years: string[];
        months: IMonth[];
        days: string[];

        constructor(
            private $scope: angular.IScope
        ) {
            const date = new Date();
            const year = date.getFullYear();

            this.years = [];
            this.months = [];
            this.days = [];

            for (let i = 0; i < 100; i++) {
                this.years.push((year - i).toString());
            }

            this.months = [
                { id: '01', label: 'January' },
                { id: '02', label: 'February' },
                { id: '03', label: 'March' },
                { id: '04', label: 'April' },
                { id: '05', label: 'May' },
                { id: '06', label: 'June' },
                { id: '07', label: 'July' },
                { id: '08', label: 'August' },
                { id: '09', label: 'September' },
                { id: '10', label: 'October' },
                { id: '11', label: 'November' },
                { id: '12', label: 'December' }
            ];

            for (let i = 1; i <= 31; i++) {
                if (i < 10) {
                    this.days.push('0' + i.toString());
                } else {
                    this.days.push(i.toString());
                }
            }
        }

        get year() {
            return this._year;
        }

        set year(value: string) {
            this._year = value;

            if (this._year && this._month && this._day) {
                this.full = `${this._month}/${this._day}/${this._year}`;
            }
        }

        get month() {
            return this._month;
        }

        set month(value: string) {
            this._month = value;

            if (this._year && this._month && this._day) {
                this.full = `${this._month}/${this._day}/${this._year}`;
            }
        }

        get day() {
            return this._day;
        }

        set day(value: string) {
            this._day = value;

            if (this._year && this._month && this._day) {
                this.full = `${this._month}/${this._day}/${this._year}`;
            }
        }

        get full() {
            const date = this.$scope.$eval(`${this.key}`);

            if (date && date instanceof Date) {
                const year = date.getFullYear().toString();
                const month = date.getMonth() < 9 ? ('0' + (date.getMonth() + 1).toString()) : (date.getMonth() + 1).toString();
                const day = date.getDate() < 10 ? ('0' + date.getDate().toString()) : date.getDate().toString();

                return `${month}/${day}/${year}`;
            }

            return '';
        }

        set full(value: string) {
            let date: Date = null;

            if (value && value.length === 10) {
                const month = parseInt(value.substr(0, 2));
                const day = parseInt(value.substr(3, 2));
                const year = parseInt(value.substr(6, 4));

                date = new Date(year, month - 1, day);
            }

            this.$scope.$eval(`${this.key}=d`, { d: date });

			if (this.tcForm.ngForm[`${this.id}_month`].$dirty || this.tcForm.ngForm[`${this.id}_day`].$dirty || this.tcForm.ngForm[`${this.id}_year`].$dirty) {
				this.tcForm.ngForm[`${this.id}`].$setDirty();

				if (this.change) {
					this.change();
				}
			}
        }

		isDisabled(): boolean {
			return this.disabled === 'true' || (this.tcForm && this.tcForm.isDisabled());
		}

		//onChange(): void {
		//	if (this.change) {
		//		this.change();
		//	}
		//}

        updateDays(): void {
            let year: number = parseInt(this.year);
            let month: number = parseInt(this.month);

            if (isNaN(year)) {
                year = 2000;
            }

            if (isNaN(month)) {
                month = 1;
            }

            const date = new Date(year, month, 0);
            const days: string[] = [];

            for (let i = 1; i <= date.getDate(); i++) {
                if (i < 10) {
                    days.push('0' + i.toString());
                } else {
                    days.push(i.toString());
                }
            }

            this.days = days;
        }
    }

    angular.module('app')
        .directive('tcTripleDate', [
			'$compile',
			'$stateParams',
			'dataService', (
				$compile: angular.ICompileService,
				$stateParams: angular.ui.IStateParamsService,
				dataService: ps.IDataService) => {
				return {
					bindToController: {
						change: '&?',
						disabled: '@',
						inputClass: '@',
						key: '@',
                        pattern: '@',
                        placeholderMonth: '@',
                        placeholderDay: '@',
                        placeholderYear: '@',
						readonly: '@',
						required: '@'
					},
					controller: <any>TcTripleDateController,
					controllerAs: '$date',
					link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: angular.IController) => {
						const tcTripleDate = $ctrl[0] as ITcTripleDateController;
						const tcForm = $ctrl[1] as ITcFormController;

						if (tcForm) {
							tcTripleDate.tcForm = tcForm;
							//tcForm.tcInputs.push(tcTripleDate);
						}

						const key: string = tcTripleDate.key ? tcTripleDate.key : null;

						tcTripleDate.id = key.replace(/[\.\'\$\[\]\(\)]+/g, '_');

						const inputClass = tcTripleDate.inputClass ? ' ' + tcTripleDate.inputClass : '';
						const pattern = tcTripleDate.pattern ? tcTripleDate.pattern : '/^\\d{2}/\\d{2}/\\d{4}$/';
						let inputAttrs = ['', '', '', ''];

						const date: Date = $scope.$eval(`${key}`);

						if (date && date instanceof Date) {
							tcTripleDate._year = date.getFullYear().toString();
							tcTripleDate._month = date.getMonth() < 9 ? ('0' + (date.getMonth() + 1).toString()) : (date.getMonth() + 1).toString();
							tcTripleDate._day = date.getDate() < 10 ? ('0' + date.getDate().toString()) : date.getDate().toString();
						}

						if (tcTripleDate.disabled) {
							inputAttrs[1] += `disabled="${tcTripleDate.disabled}" `;
							inputAttrs[2] += `disabled="${tcTripleDate.disabled}" `;
							inputAttrs[3] += `disabled="${tcTripleDate.disabled}" `;
						}

						if (tcTripleDate.required) {
							if (dataService.session.mode !== 'edit' && dataService.session.mode !== 'mock') {
								inputAttrs[0] += `required="${tcTripleDate.required}"`;
								inputAttrs[1] += `required="${tcTripleDate.required}"`;
								inputAttrs[2] += `required="${tcTripleDate.required}"`;
								inputAttrs[3] += `required="${tcTripleDate.required}"`;
							}
						}

						if (tcTripleDate.readonly) {
							inputAttrs[1] += `readonly="${tcTripleDate.readonly}" `;
							inputAttrs[2] += `readonly="${tcTripleDate.readonly}" `;
							inputAttrs[3] += `readonly="${tcTripleDate.readonly}" `;
						}                        

						const html =
							`<input id="${tcTripleDate.id}-input" name="${tcTripleDate.id}" ng-model="$date.full" ng-pattern="${pattern}" type="hidden" ${inputAttrs[0]} />
							<div class="row flat">
								<div class="col-xs-4">
									<select id="${tcTripleDate.id}-input-month" class="form-control ${inputClass}" name="${tcTripleDate.id}_month" ng-disabled="$date.isDisabled()" ng-model="$date.month" ng-options="item.id as item.label for item in $date.months" ng-change="$date.updateDays()" ${inputAttrs[1]}>
										<option value="">${tcTripleDate.placeholderMonth}</option>
									</select>
								</div>
								<div class="col-xs-4">
									<select id="${tcTripleDate.id}-input-day" class="form-control ${inputClass}" name="${tcTripleDate.id}_day" ng-disabled="$date.isDisabled()" ng-model="$date.day" ng-options="item for item in $date.days" ${inputAttrs[2]}>
										<option value="">${tcTripleDate.placeholderDay}</option>
									</select>
								</div>
								<div class="col-xs-4">
									<select id="${tcTripleDate.id}-input-year" class="form-control ${inputClass}" name="${tcTripleDate.id}_year" ng-disabled="$date.isDisabled()" ng-model="$date.year" ng-options="item for item in $date.years" ng-change="$date.updateDays()" ${inputAttrs[3]}>
										<option value="">${tcTripleDate.placeholderYear}</option>
									</select>
								</div>
							</div>`;

						$element.html(html);
						$compile($element.contents() as any)($scope);

						tcTripleDate.pattern = pattern;
					},
					restrict: 'E',
					require: ['tcTripleDate', '?^tcForm'],
					scope: true
				};
			}
		]
	);
}